/** Docs URLs for the header help icon, keyed by longest matching route prefix. */
export const TAB_HELP_DOCS: ReadonlyArray<{ prefix: string; url: string }> = [
  // Keyword Tracker
  {
    prefix: '/keyword-tracker/keywords',
    url: 'https://mizfa.tools/docs/tools/keyword-tracker/keywords-manager/'
  },
  {
    prefix: '/keyword-tracker/rank-historical',
    url: 'https://mizfa.tools/docs/tools/keyword-tracker/rank-historical/'
  },
  {
    prefix: '/keyword-tracker/map',
    url: 'https://mizfa.tools/docs/tools/keyword-tracker/keyword-map/'
  },
  {
    prefix: '/keyword-tracker/groups',
    url: 'https://mizfa.tools/docs/tools/keyword-tracker/categories/'
  },
  {
    prefix: '/keyword-tracker/tags',
    url: 'https://mizfa.tools/docs/tools/keyword-tracker/tags/'
  },
  {
    prefix: '/keyword-tracker/landing-urls',
    url: 'https://mizfa.tools/docs/tools/keyword-tracker/landing-urls/'
  },
  {
    prefix: '/keyword-tracker/competitors',
    url: 'https://mizfa.tools/docs/tools/keyword-tracker/competitors/'
  },

  // Keyword Research
  {
    prefix: '/keyword-research/massive',
    url: 'https://mizfa.tools/docs/tools/keyword-research/related-keywords/'
  },
  {
    prefix: '/keyword-research/ai-keywords',
    url: 'https://mizfa.tools/docs/tools/keyword-research/ai-keywords/'
  },
  {
    prefix: '/keyword-research/keyword-gsc',
    url: 'https://mizfa.tools/docs/tools/keyword-research/gsc-keywords/'
  },
  {
    prefix: '/keyword-research/planner',
    url: 'https://mizfa.tools/docs/tools/keyword-research/keyword-planner/'
  },
  {
    prefix: '/keyword-research/keyword-gap',
    url: 'https://mizfa.tools/docs/tools/keyword-research/keyword-gap/'
  },
  {
    prefix: '/keyword-research/competitors',
    url: 'https://mizfa.tools/docs/tools/keyword-research/competitor-keywords/'
  },
  {
    prefix: '/keyword-research/search-volume',
    url: 'https://mizfa.tools/docs/tools/keyword-research/search-volume/'
  },
  {
    prefix: '/keyword-research/clustering',
    url: 'https://mizfa.tools/docs/tools/keyword-research/clustering/'
  },

  // AI Tracker
  {
    prefix: '/tracker-ai/overview',
    url: 'https://mizfa.tools/docs/tools/ai-tracker/dashboard/'
  },
  {
    prefix: '/tracker-ai/prompts',
    url: 'https://mizfa.tools/docs/tools/ai-tracker/prompts/'
  },
  {
    prefix: '/tracker-ai/executions',
    url: 'https://mizfa.tools/docs/tools/ai-tracker/runs/'
  },
  {
    prefix: '/tracker-ai/competitors',
    url: 'https://mizfa.tools/docs/tools/ai-tracker/competitors/'
  },

  // Content Tools
  {
    prefix: '/content-tools/ai-analysis/overview',
    url: 'https://mizfa.tools/docs/tools/content-tools/overview/'
  },
  {
    prefix: '/content-tools/ai-analysis/seo',
    url: 'https://mizfa.tools/docs/tools/content-tools/seo-analysis/'
  },
  {
    prefix: '/content-tools/ai-analysis/eeat',
    url: 'https://mizfa.tools/docs/tools/content-tools/eeat-analysis/'
  },
  {
    prefix: '/content-tools/ai-analysis/geo',
    url: 'https://mizfa.tools/docs/tools/content-tools/geo-analysis/'
  },
  {
    prefix: '/content-tools/ai-analysis/detector',
    url: 'https://mizfa.tools/docs/tools/content-tools/ai-detection/'
  },

  // SERP Tools
  {
    prefix: '/serp/history',
    url: 'https://mizfa.tools/docs/tools/serp-tools/history/'
  },
  {
    prefix: '/serp/overview',
    url: 'https://mizfa.tools/docs/tools/serp-tools/overview/'
  },
  {
    prefix: '/serp/results',
    url: 'https://mizfa.tools/docs/tools/serp-tools/results/'
  },
  {
    prefix: '/serp/content-brief',
    url: 'https://mizfa.tools/docs/tools/serp-tools/content-brief/'
  },

  // Indexer
  {
    prefix: '/indexer/overview',
    url: 'https://mizfa.tools/docs/tools/indexer/overview/'
  },
  {
    prefix: '/indexer/index',
    url: 'https://mizfa.tools/docs/tools/indexer/index-request/'
  },
  {
    prefix: '/indexer/url-inspection',
    url: 'https://mizfa.tools/docs/tools/indexer/index-status/'
  },
  {
    prefix: '/indexer/urls',
    url: 'https://mizfa.tools/docs/tools/indexer/url-list/'
  },
  {
    prefix: '/indexer/changes',
    url: 'https://mizfa.tools/docs/tools/indexer/changes/'
  },
  {
    prefix: '/indexer/settings',
    url: 'https://mizfa.tools/docs/tools/indexer/settings/'
  },

  // Site Audit
  {
    prefix: '/crawl/history',
    url: 'https://mizfa.tools/docs/tools/site-audit/new-crawl/'
  },
  {
    prefix: '/crawl/overview',
    url: 'https://mizfa.tools/docs/tools/site-audit/overview/'
  },
  {
    prefix: '/crawl/check-list',
    url: 'https://mizfa.tools/docs/tools/site-audit/checklist/'
  },
  {
    prefix: '/crawl/pages',
    url: 'https://mizfa.tools/docs/tools/site-audit/pages/'
  },
  {
    prefix: '/crawl/linkgraph',
    url: 'https://mizfa.tools/docs/tools/site-audit/link-graph/'
  },
  {
    prefix: '/crawl/internal-link',
    url: 'https://mizfa.tools/docs/tools/site-audit/internal-links/'
  },
  {
    prefix: '/crawl/external-link',
    url: 'https://mizfa.tools/docs/tools/site-audit/external-links/'
  },

  // Page Analyze
  {
    prefix: '/analysis/history',
    url: 'https://mizfa.tools/docs/tools/page-analyze/history/'
  },
  {
    prefix: '/analysis/overview',
    url: 'https://mizfa.tools/docs/tools/page-analyze/overview/'
  },
  {
    prefix: '/analysis/comparison',
    url: 'https://mizfa.tools/docs/tools/page-analyze/comparison/'
  },
  {
    prefix: '/analysis/internal-seo',
    url: 'https://mizfa.tools/docs/tools/page-analyze/on-page-seo/'
  },
  {
    prefix: '/analysis/speed',
    url: 'https://mizfa.tools/docs/tools/page-analyze/speed/'
  },
  {
    prefix: '/analysis/crux',
    url: 'https://mizfa.tools/docs/tools/page-analyze/crux-report/'
  },

  // Backlinks
  {
    prefix: '/backlink/overview',
    url: 'https://mizfa.tools/docs/tools/backlinks/overview/'
  },
  {
    prefix: '/backlink/backlinks',
    url: 'https://mizfa.tools/docs/tools/backlinks/backlinks-list/'
  },
  {
    prefix: '/backlink/referral-domain',
    url: 'https://mizfa.tools/docs/tools/backlinks/referring-domains/'
  },
  {
    prefix: '/backlink/spam-domain',
    url: 'https://mizfa.tools/docs/tools/backlinks/spam-domains/'
  },
  {
    prefix: '/backlink/referring-ip',
    url: 'https://mizfa.tools/docs/tools/backlinks/referring-ips/'
  },
  {
    prefix: '/backlink/anchor-text',
    url: 'https://mizfa.tools/docs/tools/backlinks/anchor-text/'
  },
  {
    prefix: '/backlink/internal-page',
    url: 'https://mizfa.tools/docs/tools/backlinks/target-urls/'
  },

  // Settings
  {
    prefix: '/settings/mcp',
    url: 'https://mizfa.tools/docs/mcp/'
  }
];

const matchesPrefix = (pathname: string, prefix: string): boolean =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

export const resolveTabHelpDocs = (pathname: string): string | null => {
  let best: { prefix: string; url: string } | null = null;

  TAB_HELP_DOCS.forEach(item => {
    if (
      matchesPrefix(pathname, item.prefix) &&
      (!best || item.prefix.length > best.prefix.length)
    ) {
      best = item;
    }
  });

  return best?.url ?? null;
};
